import { connect } from 'react-redux'
import CSSTransitionRTG from 'react-transition-group/CSSTransition'
import React from 'react'
import block from 'bemboo'

import { transitionTime } from '../../../utils'

import AddCalendarModal from '../../Admin/Appointment/AppointmentAgenda/AddCalendarModal/AddCalendarModal'
import ClickToCallModal from '../../Admin/modals/ClickToCallModal'
import DeletedAccountModal from './DeletedAccountModal'
import LoginModal from './LoginModal'
import NewsletterModal from './NewsletterModal'
import PersonShortcutModal from './PersonShortcutModal'
import RGPDModal from './RGPDModal'
import ReviewModal from '../../Admin/modals/ReviewModal'
import shielded from '../../../hoc/shielded'
import UserProfileDeleteModal from './UserProfileDeleteModal'

import ScheduleRulesModal from '../../Admin/Pharmacy/Informations/TimeBlock/ScheduleRulesModal'

@connect(state => ({
  modal: state.modal,
}))
@shielded('Modals')
@block
export default class Modals extends React.PureComponent {
  render(b) {
    const { modal } = this.props
    return (
      <div className={b}>
        <CSSTransitionRTG
          in={modal.login}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={transitionTime}
        >
          <LoginModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.clickToCall}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={transitionTime}
        >
          <ClickToCallModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.review}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={transitionTime}
        >
          <ReviewModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.personShortcut}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={0}
        >
          <PersonShortcutModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.newsletter}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={0}
        >
          <NewsletterModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.rgpd}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={0}
        >
          <RGPDModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.userProfileDelete}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={0}
        >
          <UserProfileDeleteModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.deletedAccount}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={0}
        >
          <DeletedAccountModal />
        </CSSTransitionRTG>
        <CSSTransitionRTG
          in={modal.addCalendar}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={transitionTime}
        >
          <AddCalendarModal />
        </CSSTransitionRTG>

        <CSSTransitionRTG
          in={modal.scheduleRulesModal}
          mountOnEnter
          unmountOnExit
          classNames="modal"
          timeout={transitionTime}
        >
          <ScheduleRulesModal />
        </CSSTransitionRTG>
      </div>
    )
  }
}
